import moment from 'moment';
import { serializeParams } from '../../common/helpers';
import {
    FETCH_DATA,
    FETCH_COMPLETE,
    NOTIFY
} from './types';

import {
    despachos,
    customsHouses,
    customers,
    statuses,
    users,
    reports
} from '../../services';
import { COLORS } from '../../data/selects';


//Declare which services will use the container, to get catalogs etc
const services = {
  despachos,
  customsHouses,
  customers,
  statuses,
  users,
  reports
};

export const notify = (payload) => {
    return {
        type: NOTIFY,
        payload
    };
};


export const fetchCustomsHousesForListing = (service, path, url, params = {}) => {
    return (dispatch) => {
        dispatch({ type: FETCH_DATA });
        return services[service].get(url, params).then(result => {
            onDataLoaded(dispatch, [
                { path: 'isLoading', value: false },
                {
                    path,
                    value: {
                        items: result._embedded.customsHouses.map((customsHouse) => {
                            return { id: customsHouse.name, name: customsHouse.name, uuid: customsHouse.id };
                        }),
                        displayProp: (item) => item.name
                    }
                }
            ]);
        });
    };
};

export const fetchCustomer = (service, path, url, params = {}) => {
    return (dispatch) => {
        dispatch({ type: FETCH_DATA });
        return services[service].get(url, params).then(result => {
            onDataLoaded(dispatch, [
                { path: 'isLoading', value: false },
                {
                    path,
                    value: {
                        items: result._embedded.customers.map((customer) => {
                            return { id: customer.name, name: customer.name, uuid: customer.id };
                        }),
                        displayProp: (item) => item.name
                    }
                }
            ]);
        });
    };
};

export const fetchStatus = (service, path, url, params = {}) => {
    return (dispatch) => {
        dispatch({ type: FETCH_DATA });
        return services[service].get(url, params).then(result => {
            onDataLoaded(dispatch, [
                { path: 'isLoading', value: false },
                {
                    path,
                    value: {
                        items: result._embedded.clearenceStatuses.map((clearenceStatus) => {
                            return { id: clearenceStatus.statusName, name: clearenceStatus.statusName, uuid: clearenceStatus.id };
                        }),
                        displayProp: (item) => item.name
                    }
                }
            ]);
        });
    };
};

export const fetchUsers = (service, path, url, params = {}) => {
    return (dispatch) => {
        dispatch({ type: FETCH_DATA });
        return services[service].get(url, params).then(result => {
          onDataLoaded(dispatch, [
              { path: 'isLoading', value: false },
              {
                  path,
                  value: {
                      items: result._embedded.users.map((user) => {
                          return { id: user.name, name: user.name, uuid: user.id };
                      }),
                      displayProp: (item) => item.name
                  }
              }
          ]);
      });
    };
};

export const fetchcustomsClearence = ( SearchThis , path,  params = {}) => {

  var url = '';
  switch (SearchThis.auxButton) {
    case 'CustomsHouse':
        delete SearchThis.auxButton;
        var filter = serializeParams(SearchThis);
        filter = filter.replace("ATS", "&arrivalTimestamp=")
        url = 'customsClearences'+filter+'&projection=customsClearenceInLine';
      break;
      case 'Customer':
          delete SearchThis.auxButton;
          var filter = serializeParams(SearchThis);
          filter = filter.replace("ATS", "&arrivalTimestamp=")
          url = 'customsClearences'+filter+'&projection=customsClearenceInLine';
        break;
      case 'Status':
          delete SearchThis.auxButton;
          var filter = serializeParams(SearchThis);
          filter = filter.replace("ATS", "&arrivalTimestamp=")
          url = 'customsClearences'+filter+'&projection=customsClearenceInLine';
        break;
      case 'User':
          delete SearchThis.auxButton;
          var filter = serializeParams(SearchThis);
          filter = filter.replace("ATS", "&arrivalTimestamp=")
          url = 'customsClearences'+filter+'&projection=customsClearenceInLine';
        break;
    default:

  }

    return (dispatch) => {
        dispatch({ type: FETCH_DATA });
        return services['despachos'].get(url, params).then(data => {
            onDataLoaded(dispatch, [
                { path, value: data._embedded.customsClearences }
            ]);
        });
    };
};



export const getURL = (params) => {
  var url = ""
  switch (params.buttonValue) {
    case "PorCliente":
        url = 'reports/xlsByCustomer?customerId='+params.value.customer+'&startDate='+params.value.minDateByCustomer+'&endDate='+params.value.maxDateByCustomer;
      break;
    case "PorAduana":
        url = 'reports/xlsByCustomsHouse?customsHouse='+params.value.customsHouse+'&startDate='+params.value.minDateByCustomHouse+'&endDate='+params.value.maxDateByCustomHouse;
      break;
    case "PorEstado":
        url = 'reports/xlsByStatus?status='+params.value.status+'&startDate='+params.value.minDateByStatus+'&endDate='+params.value.maxDateByStatus;
      break;
    case "PorUsuario":
        url = 'reports/xlsByUser?operativeUserId='+params.value.user+'&startDate='+params.value.minDateByUser+'&endDate='+params.value.maxDateByUser;
      break;
    default:

  }
  return url
};

export const fetchReports = (service, path, informationReport, params = {}) => {

  var url = getURL(informationReport);

    return (dispatch) => {
        dispatch({ type: FETCH_DATA });
        return services[service].get(url, params).then(result => {
          getReport(result, informationReport);
      });
  };
};

const getReport = (result, informationReport) => {

  var byteString = atob(result);
  // Convert that text into a byte array.
  var ab = new ArrayBuffer(byteString.length);
  var ia = new Uint8Array(ab);
  for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
  };

  // Blob for saving.
  var blob = new Blob([ia], { type: "octet/stream" });
  var url = window.URL.createObjectURL(blob);
  var a = document.createElement("a");
  document.body.appendChild(a);
   a.href = url;
   a.download = "Reporte"+informationReport.buttonValue+"/FechaDeCreacion="+moment(new Date()).format('DD-MM-YYYY')+".xls";
   a.click();
   window.URL.revokeObjectURL(url);

}
const onDataLoaded = (dispatch, targets) => {
    dispatch({
        type: NOTIFY,
        payload: { op: 'multiUpdate', targets }
    });
};



// WEBPACK FOOTER //
// ./containers/reportes/actions.js